import { makeStyles } from '@mui/styles';

const commonFormWrap = {
  display: 'flex',
  margin: '1rem'
};

export const useStyles = makeStyles((theme) => ({
  personalInfoContainer: {
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  fullWidth: {
    width: '100%'
  },
  tooltipLabel: {
    display: 'flex',
    alignItems: 'center'
  },
  toolTipIcon: {
    color: '#6FADCC',
    width: 17,
    height: 17,
    marginLeft: '5px'
  },
  subTextColor: {
    color: theme.palette.primary.main
  },
  formPageNumber: {
    fontSize: 16,
    textAlign: 'right',
    padding: '0.5rem 0.75rem 0 0',
    [theme.breakpoints.down(370)]: {
      fontSize: 12,
    }
  },
  contentTitleWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0.625rem 0 1rem 0',
  },
  contentTitleLine: {
    width: '100%',
    height: 0,
    border: '1px solid #567282',
    display: 'inline-block',
    background: '#567282'
  },
  titleLine1: {
    margin: '4px 10px 0 26px',
  },
  titleLine2: {
    margin: '4px 26px 0 10px',
  },
  contentTitle: {
    color: theme.palette.primary.dark,
    fontSize: 20,
    fontWeight: '500',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down(370)]: {
      fontSize: 16,
    }
  },
  addrAptContainer: commonFormWrap,
  addrContainer: {
    marginRight: '1rem',
    minWidth: '70%'
  },
  cityStateZipContainer: commonFormWrap,
  cityContainer: {
    marginRight: '1rem',
    minWidth: '44%'
  },
  stateContainer: {
    marginRight: '1rem',
    minWidth: '22%'
  },
  ssnBiosexContainer: commonFormWrap,
  ssnContainer: {
    marginRight: '1rem',
    minWidth: '50%'
  },
  racePrimaryLangContainer: commonFormWrap,
  rangContainer: {
    marginRight: '1rem',
    minWidth: '50%'
  },
  emailPhContainer: commonFormWrap,
  emailContainer: {
    marginRight: '1rem',
    minWidth: '50%'
  },
  checkboxContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  checkboxText: {
    fontSize: 16,
    [theme.breakpoints.down(370)]: {
      fontSize: 12,
    }
  },
  buttonsNavContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '3rem 1rem 1.5rem 1rem'
  },
  errorText: {
    color: theme.palette.error.main,
    fontSize: 14,
    margin: '2px 0 0 4px',
  },
  btnDisabled: {
    background: theme.palette.common.grey,
    color: '#9e9e9e',
    '&:hover': {
      background: theme.palette.common.grey,
      color: '#9e9e9e',
    }
  }
}));
